// Hooks / Node modules / Styles
import { useState } from "react";

// Reducers / Actions

// Utils / Functions

// Components
import LifestyleCard from "./LifestyleCard";

// Sub-Components

// Data / Images / Icons
import { LIFESTYLE } from "src/data/pages/lifestyle";

function LifestyleCardGroup() {
  const [activeIndex, setActiveIndex] = useState({}); // Manage active index for each post

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {LIFESTYLE.map((post) => (
        <LifestyleCard
          key={post.id}
          post={post}
          activeIndex={activeIndex}
          setActiveIndex={setActiveIndex} // Pass down state management
        />
      ))}
    </div>
  );
}

export default LifestyleCardGroup;
